import { AccountModel, DialogHandler, EEditorType, EStorageType, getStorage, TBrand } from "@cakemail-org/ui-components-v2"
import { EFeatureFlags, hasFeatureFlag } from "../../../utils/limits_features"
import { t } from "i18next"
import { BeeContentDialogs } from "@beefree.io/sdk/dist/types/bee"
import { EEditorCacheKeys, TBeeEditorContentContext } from "../types"
import { showFormContentDialog } from "../contentDialogs/forms"

export function getAddOns({ account, partnerBrand, userBrand }: { account: AccountModel; partnerBrand: TBrand; userBrand?: TBrand }) {
    return []
}

export function getContentDialogConfig({ editorType, getContentContext, getLocalContent }: { editorType: EEditorType, getContentContext: () => TBeeEditorContentContext, getLocalContent: () => any }) {
    return {
        addOn: {
            //@ts-ignore
            handler: (resolve, reject, args) => {
                reject()
            },
        },
        onEditRow: {
            //@ts-ignore
            handler: async (resolve, reject, args) => {
                reject()
            },
        },
        saveRow: {
            //@ts-ignore
            handler: async (resolve, reject, row) => {
                reject()
            },
        },
        onDeleteRow: {
            //@ts-ignore
            handler: async (resolve, reject, args) => {
                reject()
            },
        },
        //Dropdown option to search DIALOG LIKE MERGE TAGS
        /*externalContentURLs: {
            label: 'Search products',
            handler: function (resolve, reject, args) {}
        },*/
        mergeTags: {
            label: t("app-general-merge-tag"),
            //@ts-ignore
            handler: (resolve, reject) => {
                reject()
            },
        },
        /*rowDisplayConditions: {
            label: 'Manage display condition',
            handler: function (resolve, reject, currentCondition) {
                DialogHandler.show({
                    title: "Title",
                    content: "Content",
                    managedByContent: true
                });
            }
        },*/
        manageForm: {
            label: t("general-edit-form"),
            //@ts-ignore
            handler: async (resolve, reject, args) => {
                showFormContentDialog({ resolve, reject, args, getContentContext })
            }
        }
    }
}
